import React from 'react'
import { Helmet } from 'react-helmet'

const HelmetMeta = props => {
  const url = window.location.href
  return (
    <Helmet>
      <title>{`${props.goal} ${props.subhead}: ${props.headline}`}</title>
      <meta name='title' content={props.headline} />
      <meta name='description' content={props.subhead} />
      <meta name='keywords' content={props.keywords} />
      <meta name='news_keywords' content={props.keywords} />
      <link rel='image_src' href={props.promo} />

      <meta property='og:url' content={url} />
      <meta property='og:title' content={props.headline} />
      <meta
        property='og:site_name'
        content='The Atlas of Sustainable Development Goals 2020'
      />
      <meta property='og:description' content={props.subhead} />
      <meta property='og:type' content='article' />
      <meta property='og:test' content={props.promo} />
      <meta property='og:image:type' content='image/jpg' />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:image' content={props.promo} />

      <meta name='twitter:card' content='summary' />
      <meta
        name='twitter:site'
        content='The Atlas of Sustainable Development Goals 2020'
      />
      <meta name='twitter:title' content={props.headline} />
      <meta name='twitter:description' content={props.subhead} />
      <meta name='twitter:image:src' content={props.promo} />
      <meta name='dcterms.title' content={props.headline} />
      <meta name='dcterms.type' content='Text/HTML' />
      <meta name='dcterms.identifier' content={url} />
      <meta name='dcterms.language' content='en' />
    </Helmet>
  )
}

export default HelmetMeta
